// extracted by mini-css-extract-plugin
module.exports = {"toolbarButton":"Toolbox_toolbarButton__LN5xM","clearIcon":"Toolbox_clearIcon__17XWM","toolboxItem":"Toolbox_toolboxItem__KiEZs","inactiveButton":"Toolbox_inactiveButton__2EQdX"};